type Props = {
  tokenName: string;
  className?: string;
};
export const UnknownTokenLogo = ({ tokenName, className }: Props) => {
  return (
    <div
      className={`rounded-full bg-white shadow-sm flex items-center justify-center text-black ${className}`}
    >
      {tokenName.substring(0, 1)}
    </div>
  );
};
